import baseConfig from "./base/production.config";
import pulseConfig from "./pulse/production.config";

const config = {
  base: baseConfig,
  pulse: pulseConfig,
};

export default config;
